import React from "react";

import {stateToHTML} from 'draft-js-export-html';
import Modifier from "draft-js/lib/DraftModifier";
import {CircularProgress} from "@mui/joy";

import Box from "@mui/joy/Box";

// components
import BaseApi from "../../utils/BaseApi";
import MUIRichTextEditor from '../MuiRte/MUIRichTextEditor.tsx'
import ProfileHorizontalByProps from "../Profile/ProfileHorizontalByProps";
import EditorState from "draft-js/lib/EditorState";
import CommentReplyCard from "./CommentReplyCard";
import ContactCard from "../Cards/ContactCard";

// icons
import TelegramIcon from "@mui/icons-material/Telegram";
import Button from "@mui/joy/Button";


class CommentForm extends React.Component {
    constructor(props) {
        super(props);
        this.rte = React.createRef()
        this.state = {
            mention_process: false,
            mention_filter: '',
            users: null,
            contacts: null,
            value: this.props.value ? this.props.value : '',
            replyTo: this.props.replyTo ? this.props.replyTo : null,
        };
        let editorState = EditorState.createEmpty()
        this.state['editorState'] = editorState
        if (this.props.value){
            let content = Modifier.insertText(
                editorState.getCurrentContent(),
                editorState.getSelection(),
                this.props.value,
            )
            this.state['content'] = content
        }

    }

    componentDidCatch(error, errorInfo) {
        this.forceUpdate();
    }

    reply(comment){
        let value = '@' + comment.owner.username
        let content = Modifier.insertText(
            this.state.editorState.getCurrentContent(),
            this.state.editorState.getSelection(),
            value,
        )
        this.setState(
            {
                content: content,
                replyTo: comment,
            }
        )
    }

    async retrieveUsers() {
        const url = 'user/';
        const api = new BaseApi();
        let response = await api.get(
            url,
            {}
        )
        this.setState(
            {
                users: response.data.results.map(each => {
                    return (
                        {
                            keys: [each.username],
                            value: '@' + each.username,
                            content: <ProfileHorizontalByProps
                                user={each}
                                key={'ProfileHorizontalByProps'+crypto.randomUUID()}
                            />,
                        }
                    )
                })
            }
        );
    }

    async retrieveContacts() {
        let url;
        const api = new BaseApi();
        let account = null;
        let contacts = []
        if (this.props.appName === 'Account'){
            account = this.props.appId
        }
        if (this.props.appName === 'Opportunity'){
            url = 'opportunity/' + this.props.appId + '/card/';
            let response = await api.get(
                url,
                {}
            )
            account =  response.data.opportunity.account.id
        }
        if (account){
            url = 'contact/';
            let response = await api.get(
                url,
                {
                    entity: 'Account',
                    entity_id: account,
                    page_size: 10000,
                }
            )
            contacts = response.data.results.map(each => {
                return (
                    {
                        keys: [
                            each.last_name?each.last_name:' ',
                            each.first_name?each.first_name:' ',
                            each.patronymic?each.patronymic:' ',
                            each.last_name?each.last_name.toLowerCase():' ',
                            each.first_name?each.first_name.toLowerCase():' ',
                            each.patronymic?each.patronymic.toLowerCase():' ',
                        ],
                        value: `#${each.id}# {{${each.last_name?each.last_name:''}${each.first_name?each.first_name:''}${each.patronymic?each.patronymic:''}}}`,
                        content: <ContactCard
                            hideLink={true}
                            mini={true}
                            contact={each}
                            key={'ContactCardMini'+crypto.randomUUID()}
                        />,
                    }
                )
            })
        }
        this.setState(
            {
                contacts: contacts
            }
        );
    }

    async componentDidMount() {
        await this.retrieveUsers();
        await this.retrieveContacts();
    }

    componentDidUpdate(prevProps) {
        if (this.props.initialValue !== prevProps.initialValue) {
            this.setState({value: this.props.initialValue ?? ''})
        }
    }

    handleEditorChange(state) {
        this.setState(
            {
                value: stateToHTML(state.getCurrentContent()),
                editorState: state,
            }
        );
    }

    clearReplyTo(){
        this.setState(
            {
                replyTo: null,
            }
        )
    }

    async postComment(){
        let data = {
            type: "comment",
            content: this.state.value,
            reply_to: this.state.replyTo?.id,
            xtype: this.state.replyTo?.xtype,
            related_app: this.props.appName,
            related_app_id: this.props.appId,
        };
        const api = new BaseApi();
        const url = 'comment/'
        let response = await api.post(
            url,
            data
        );
        if (response.status === 201){
            if (this.props.callBack){
                await this.props.callBack(response.data)
            }
        }
    }

    render() {
        if (!this.state.users || !this.state.contacts) {
            return (<CircularProgress />)
        }
        return(
            <>
                <Box
                    sx={{
                        height: this.state.replyTo?'320px':'220px',
                        overflowY: 'scroll',
                    }}
                >
                    {
                        this.state.replyTo?
                            <CommentReplyCard
                                comment={this.state.replyTo}
                                deleteCallBack={this.clearReplyTo.bind(this)}
                            />:
                            null
                    }
                    <MUIRichTextEditor
                        ref={this.rte}
                        id={'comment-form'}
                        controls={[
                            "title",
                            "bold",
                            "italic",
                            "numberList",
                            "bulletList",
                            "increase-indent",
                            "clear",
                        ]}
                        // customControls={[
                        //     {
                        //         name: "increase-indent",
                        //         icon: <FormatIndentIncreaseIcon />,
                        //         type: "block",
                        //         blockWrapper: <ol />
                        //     }
                        // ]}
                        defaultValue={this.state.content}
                        label="Начните набор..."
                        onChange={this.handleEditorChange.bind(this)}
                        autocomplete={{
                            strategies: [
                                {
                                    items: this.state.users,
                                    triggerChar: "@",
                                    insertSpaceAfter: true
                                },
                                {
                                    items: this.state.contacts,
                                    triggerChar: "#",
                                    insertSpaceAfter: true
                                },
                            ]
                        }}
                    />


                </Box>
                {
                    this.props.inlineReply?
                        <Button
                            size={'sm'}
                            color="primary"
                            onClick={this.postComment.bind(this)}
                        >
                            <TelegramIcon
                                sx={{mr: 2}}
                            />
                            Отправить
                        </Button>:
                        null
                }
            </>
        )
    }
}

export default CommentForm;
